import "./App.css";
import "./ui_components/index.css";
import { VStack } from "@chakra-ui/react";
import { RouteManager } from "./wrappers/routes";
import CopyTooltipPortal from "./ui_components/copyTooltipPortal";
import { useEffect } from "react";

function App() {
  return (
    <VStack
      w="full"
      h="full"
      bg="inherit"
      justify={"center"}
      align={"center"}
      color={"white"}
    >
      <CopyTooltipPortal />
      <RouteManager />
    </VStack>
  );
}

export default App;
